import { gql, useQuery } from "@apollo/client";
import { Grid } from "@mui/material";
import { ErrorComponent } from "@src/components";
import { DetailPageHeader } from "@src/components/headers/DetailPageHeader";
import LoadingComponent from "@src/components/LoadingComponent";
import { type GQLCodeAdminQuery, type GQLCodeAdminQueryVariables } from "@src/graphql.generated";
import { type FC, type PropsWithChildren } from "react";

import CodeInformation from "./CodeInformation";
// eslint-disable-next-line @comet/no-private-sibling-import
import { codeFragment } from "./fragments.gql";

const codeQuery = gql`
    query CodeAdmin($id: ID!) {
        licenceAdmin(id: $id) {
            ...CodeFragment
        }
    }
    ${codeFragment}
`;

interface Props {
    id: string;
}

export const ViewCode: FC<PropsWithChildren<Props>> = ({ id }) => {
    const { data, error, loading } = useQuery<GQLCodeAdminQuery, GQLCodeAdminQueryVariables>(codeQuery, { variables: { id } });

    if (error) {
        return <ErrorComponent />;
    }

    if (loading || !data) {
        return <LoadingComponent />;
    }

    return (
        <>
            <DetailPageHeader />
            <Grid container spacing={4}>
                <Grid size={6}>
                    <CodeInformation licenceAdmin={data.licenceAdmin} />
                </Grid>
            </Grid>
        </>
    );
};
